import React from 'react';
import { MDText } from 'i18n-react';

import Content from 'Storybook/local/Content/Content';

import texts from '../texts.json';

import { TestimonialVideo } from './TestimonialVideo';

import styles from './Testimonials.module.scss';

const LocalT = new MDText(texts.homePage.testimonials);

const testimonialVideos = [
	{
		description: LocalT.translate('description1'),
		heading: LocalT.translate('heading1'),
		youtubeVideoId: 'D6sTad5aL5c',
	},
];

const NewTestimonials = (): React.ReactElement => {
	return (
		<Content
			center
			className={styles.testimonials}
			element="section"
			id="testimonials"
			wrapper={{
				className: `${styles.testimonialsWrapper} ${styles.newTestimonials}`,
			}}
		>
			<section className={styles.testimonialContainer}>
				<div className={styles.testimonialInnerContainer}>
					{testimonialVideos.map((video) => {
						const { description, heading, youtubeVideoId } = video;

						return (
							<figure key={youtubeVideoId} className={styles.video}>
								<TestimonialVideo
									key={youtubeVideoId}
									description={description as string}
									heading={heading as string}
									youtubeVideoId={youtubeVideoId}
								/>
							</figure>
						);
					})}
				</div>
			</section>
		</Content>
	);
};

export default NewTestimonials;
